import { render, staticRenderFns } from "./NsProgress.vue?vue&type=template&id=810b4508&scoped=true&"
import script from "./NsProgress.vue?vue&type=script&lang=js&"
export * from "./NsProgress.vue?vue&type=script&lang=js&"
import style0 from "./NsProgress.vue?vue&type=style&index=0&id=810b4508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810b4508",
  null
  
)

export default component.exports